
export const DOCTOR_HOW_IT_WORKS_PAGES = {
  DASHBOARD: {
    key: 'dashboard',
    label: 'Dashboard',
    order: 1
  },
  APPOINTMENTS: {
    key: 'appointments',
    label: 'Appointments',
    order: 2
  },
  PATIENTS: {
    key: 'patients',
    label: 'Patients',
    order: 3
  },
  INVOICES: {
    key: 'invoices',
    label: 'Invoices',
    order: 4
  },
  REPORT: {
    key: 'report',
    label: 'Report',
    order: 5
  },
  CALENDAR: {
    key: 'calendar',
    label: 'Calendar',
    order: 6
  },
  VIDEO_CALL: {
    key: 'video-call',
    label: 'Video Call',
    order: 7
  },
  DICOM: {
    key: 'dicom',
    label: 'DICOM',
    order: 8
  }
} as const;
